export const SaaSCoType = "SaaS";
export const GeneralCoType = "General";
